module.exports = __webpack_public_path__ + "img/267-1a2b57.png";